import SummaryTable from "@viz-ui/models/summaryTable/summaryTable";
import SummaryTableAdapter from "@viz-ui/models/summaryTable/summaryTableAdapter";

angular
  .module("acl.visualizer.model.summaryTable", ["acl.visualizer.dataTable", "acl.visualizer.sorters"])
  .factory("SummaryTable", () => SummaryTable)
  .factory("SummaryTableAdapter", () => SummaryTableAdapter);
